"use strict";

var _interopRequireDefault = require("/opt/build/repo/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPermissions = getPermissions;

var _request = _interopRequireDefault(require("@/utils/request"));

function getPermissions(params) {
  return (0, _request.default)({
    url: '/admin-permissions',
    method: 'get',
    params: params
  });
}